"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState, useRef, useEffect } from "react";
import HorizontalSmallImageCategoryNews from "../component_horizontal/HorizontalSmallImageCategoryNews";
type WhiteMenuBarProps = {
  tabs: string[]; // Dynamic menu names
  onChange?: (index: number) => void; // Callback on tab change
};
export default function WhiteMenuBar2(t0) {
  const $ = _c(27);
  const {
    tabs: t1,
    onChange
  } = t0;
  const tabs = t1 === undefined ? ["\u0B85\u0BA9\u0BC8\u0BA4\u0BCD\u0BA4\u0BC1", "\u0B9A\u0BC6\u0BAF\u0BCD\u0BA4\u0BBF", "\u0BA4\u0BBF\u0BB0\u0BC8/\u0B9A\u0BBF\u0BB1\u0BC1 \u0BA4\u0BBF\u0BB0\u0BC8"] : t1;
  const [active, setActive] = useState(0);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      left: 0,
      width: 0
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const [underlineStyle, setUnderlineStyle] = useState(t2);
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const tabRefs = useRef(t3);
  let t4;
  let t5;
  if ($[2] !== active) {
    t4 = () => {
      const rafId = requestAnimationFrame(() => {
        const activeTab = tabRefs.current[active];
        if (activeTab) {
          const {
            offsetLeft,
            offsetWidth
          } = activeTab;
          setUnderlineStyle({
            left: offsetLeft,
            width: offsetWidth
          });
        }
      });
      return () => cancelAnimationFrame(rafId);
    };
    t5 = [active];
    $[2] = active;
    $[3] = t4;
    $[4] = t5;
  } else {
    t4 = $[3];
    t5 = $[4];
  }
  useEffect(t4, t5);
  let t6;
  if ($[5] !== onChange) {
    t6 = index => {
      setActive(index);
      onChange?.(index);
    };
    $[5] = onChange;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const handleClick = t6;
  const t7 = "w-full";
  const t8 = "border-b border-DCDCDC h-[40px] relative";
  const t9 = "flex gap-4 sm:gap-6 md:gap-8 px-4 overflow-x-auto no-scrollbar items-center h-full";
  const t10 = tabs.map((tab, index_0) => <button key={index_0} ref={el => {
    tabRefs.current[index_0] = el;
  }} onClick={() => handleClick(index_0)} className="relative pb-1 whitespace-nowrap font-bold leading-none transition-colors duration-200"><span className={`transition-colors duration-300 ${active === index_0 ? "text-215EF9" : "text-808080 hover:text-333333"} text-12-tamil-900`}>{tab}</span></button>);
  let t11;
  if ($[7] !== t10) {
    t11 = <div className={t9}>{t10}</div>;
    $[7] = t10;
    $[8] = t11;
  } else {
    t11 = $[8];
  }
  const t12 = `${underlineStyle.left}px`;
  const t13 = `${underlineStyle.width}px`;
  let t14;
  if ($[9] !== t12 || $[10] !== t13) {
    t14 = <div className="absolute bottom-0 h-[3px] bg-215EF9 rounded-full transition-all duration-300 ease-out" style={{
      left: t12,
      width: t13
    }} />;
    $[9] = t12;
    $[10] = t13;
    $[11] = t14;
  } else {
    t14 = $[11];
  }
  let t15;
  if ($[12] !== t11 || $[13] !== t14) {
    t15 = <div className={t8}>{t11}{t14}</div>;
    $[12] = t11;
    $[13] = t14;
    $[14] = t15;
  } else {
    t15 = $[14];
  }
  const t16 = `translateX(-${active * 100}%)`;
  let t17;
  if ($[15] !== t16) {
    t17 = {
      transform: t16,
      opacity: 1
    };
    $[15] = t16;
    $[16] = t17;
  } else {
    t17 = $[16];
  }
  let t18;
  if ($[17] !== tabs) {
    t18 = tabs.map(_temp);
    $[17] = tabs;
    $[18] = t18;
  } else {
    t18 = $[18];
  }
  let t19;
  if ($[19] !== t18) {
    t19 = <div className="flex">{t18}</div>;
    $[19] = t18;
    $[20] = t19;
  } else {
    t19 = $[20];
  }
  let t20;
  if ($[21] !== t17 || $[22] !== t19) {
    t20 = <div className="w-full relative overflow-hidden"><div className="transition-all duration-500 ease-in-out" style={t17}>{t19}</div></div>;
    $[21] = t17;
    $[22] = t19;
    $[23] = t20;
  } else {
    t20 = $[23];
  }
  let t21;
  if ($[24] !== t15 || $[25] !== t20) {
    t21 = <div className={t7}>{t15}{t20}</div>;
    $[24] = t15;
    $[25] = t20;
    $[26] = t21;
  } else {
    t21 = $[26];
  }
  return t21;
}
function _temp(_, index_1) {
  return <div key={index_1} className="w-full flex-shrink-0 space-y-0" style={{
    minWidth: "100%"
  }}>{index_1 === 0 && <><HorizontalSmallImageCategoryNews category={{
        hidden: false,
        value: "\u0B9A\u0BC6\u0BAF\u0BCD\u0BA4\u0BBF"
      }} title={{
        hidden: false,
        value: "\u0B9C\u0BC7.\u0BAA\u0BBF. \u0BA8\u0B9F\u0BCD\u0B9F\u0BBE \u0B9A\u0BC6\u0BB2\u0BCD\u0BB2\u0BC1\u0BAE\u0BCD \u0B87\u0B9F\u0BAE\u0BC6\u0BB2\u0BCD\u0BB2\u0BBE\u0BAE\u0BCD \u0BAA\u0BBE\u0BA4\u0B95 \u0BA4\u0BC7\u0BB0\u0BCD\u0B95\u0BC1\u0BAE\u0BCD: \u0B9A\u0BB1\u0BCD\u0BB1\u0BC1 \u0BAF \u0BB0\u0BC6\u0BB3\u0BA4\u0BCD"
      }} timeAgo={{
        hidden: false,
        value: "15 min ago"
      }} /><HorizontalSmallImageCategoryNews category={{
        hidden: false,
        value: "\u0B85\u0BB0\u0B9A\u0BBF\u0BAF\u0BB2\u0BCD"
      }} title={{
        hidden: false,
        value: "\u0BAE\u0BA4\u0BCD\u0BA4\u0BBF\u0BAF \u0B85\u0BB0\u0B9A\u0BBF\u0BA9\u0BCD \u0BAA\u0BC1\u0BA4\u0BBF\u0BAF \u0B95\u0BCA\u0BB3\u0BCD\u0B95\u0BC8 \u0B85\u0BB1\u0BBF\u0BB5\u0BBF\u0BAA\u0BCD\u0BAA\u0BC1 \u0BB5\u0BBF\u0BB0\u0BC8\u0BB5\u0BBF\u0BB2\u0BCD"
      }} timeAgo={{
        hidden: false,
        value: "30 min ago"
      }} /><HorizontalSmallImageCategoryNews category={{
        hidden: false,
        value: "\u0BAA\u0BCA\u0BB0\u0BC1\u0BB3\u0BBE\u0BA4\u0BBE\u0BB0\u0BAE\u0BCD"
      }} title={{
        hidden: false,
        value: "\u0BB0\u0BC2\u0BAA\u0BBE\u0BAF\u0BCD \u0BAE\u0BA4\u0BBF\u0BAA\u0BCD\u0BAA\u0BC1 \u0BB5\u0BC0\u0BB4\u0BCD\u0B9A\u0BCD\u0B9A\u0BBF: \u0BB5\u0B99\u0BCD\u0B95\u0BBF \u0B95\u0B9F\u0BCD\u0B9F\u0BC1\u0BAA\u0BCD\u0BAA\u0BBE\u0B9F\u0BCD\u0B9F\u0BBE\u0BB3\u0BB0\u0BCD \u0BAA\u0BC7\u0B9F\u0BCD\u0B9F\u0BBF"
      }} timeAgo={{
        hidden: false,
        value: "1 hour ago"
      }} /></>}</div>;
}